import React from 'react';

const StatsCard = ({ 
  value, 
  label, 
  gradient = 'from-blue-600 to-indigo-600',
  className = '' 
}) => {
  return (
    <div className={`text-center p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-white/20 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 ${className}`}>
      <div className={`text-4xl font-bold bg-gradient-to-r ${gradient} bg-clip-text text-transparent mb-2`}>
        {value}
      </div>
      <div className="text-sm text-gray-600">{label}</div>
    </div>
  );
};

export default StatsCard;